export const POSTING_PREFERENCES_TITLE = 'posting-preferences.title';
export const POSTING_PREFERENCES_HIGHLIGHT_TITLE = 'posting-preferences.highlight-title';
export const POSTING_PREFERENCES_HIGHLIGHT_DESCRIPTION = 'posting-preferences.highlight-description';
export const POSTING_PREFERENCES_TEMPORARY_TITLE = 'posting-preferences.temporary-title';
export const POSTING_PREFERENCES_TEMPORARY_DESCRIPTION = 'posting-preferences.temporary-description';
export const POSTING_PREFERENCES_SHOW_GIVING_LINK_TITLE = 'posting-preferences.show-giving-link-title';
export const POSTING_PREFERENCES_PUSH_IMMEDIATELY_TITLE = 'posting-preferences.push-immediately-title';
export const POSTING_PREFERENCES_PUSH_IMMEDIATELY_DESCRIPTION = 'posting-preferences.push-immediately-description';
